function AlertIcon(props) {
  const { width, height } = props
  return (
    <svg
      width={width || '181'}
      height={height || '180'}
      viewBox="0 0 181 180"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M90.5 0C40.7991 0 0.5 40.2991 0.5 90C0.5 139.701 40.7991 180 90.5 180C140.201 180 180.5 139.701 180.5 90C180.5 40.2991 140.201 0 90.5 0ZM90.5 164.732C49.2366 164.732 15.7679 131.263 15.7679 90C15.7679 48.7366 49.2366 15.2679 90.5 15.2679C131.763 15.2679 165.232 48.7366 165.232 90C165.232 131.263 131.763 164.732 90.5 164.732Z"
        fill="#828282"
      />
      <path
        d="M80.8572 125.357C80.8572 127.915 81.8732 130.367 83.6816 132.176C85.49 133.984 87.9427 135 90.5001 135C93.0575 135 95.5102 133.984 97.3186 132.176C99.127 130.367 100.143 127.915 100.143 125.357C100.143 122.8 99.127 120.347 97.3186 118.539C95.5102 116.73 93.0575 115.714 90.5001 115.714C87.9427 115.714 85.49 116.73 83.6816 118.539C81.8732 120.347 80.8572 122.8 80.8572 125.357ZM85.6787 102.857H95.3215C96.2055 102.857 96.9287 102.134 96.9287 101.25V46.6071C96.9287 45.7232 96.2055 45 95.3215 45H85.6787C84.7947 45 84.0715 45.7232 84.0715 46.6071V101.25C84.0715 102.134 84.7947 102.857 85.6787 102.857Z"
        fill="#828282"
      />
    </svg>
  )
}

export default AlertIcon
